import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'components/library'
import './Button.css'

const Button = props => {
  const classNames = ['Button']

  if(props.primary) classNames.push('is-primary')
  if(props.square) classNames.push('is-square')
  if(props.outline) classNames.push('is-outline')
  if(props.disabled) classNames.push('is-disabled')
  if(props.icon) classNames.push('has-icon')
  if(!props.label) classNames.push('has-nolabel')
  if(props.full) classNames.push('has-fullwidth')
  if(props.fixed) classNames.push('has-fixedwidth')
  if(props.iconPos === 'top') classNames.push('has-icon-top')

  return (
    <div className={classNames.join(' ')}>
      {props.onClick && <a onClick={props.onClick} style={props.style}><ButtonContent {...props} /></a>}
      {props.to && <Link to={props.to} style={props.style}><ButtonContent {...props} /></Link>}
      {props.submit && <button type="submit" style={props.style}><ButtonContent {...props} /></button>}
      {props.static && <span className="Button-ghost" style={props.style}><ButtonContent {...props} /></span>}
    </div>
  )
}

const ButtonContent = props => {
  return (
    <React.Fragment>
      {props.icon && props.iconPos === 'top' && <Icon name={props.icon} />}
      {props.icon && !props.label && <Icon name={props.icon} />}
      {props.icon && props.iconPos === 'left' && <Icon name={props.icon} />}
      {props.label && <span className="Button-label">{props.label}</span>}
      {props.icon && props.iconPos === 'right' && <Icon name={props.icon} />}
    </React.Fragment>
  )
}

const ButtonsGroup = props => (
  <div className="Buttons-group">
    {props.children}
  </div>
)

Button.defaultProps = {
  label: ''
}

export default Button
export { ButtonsGroup }



// WEBPACK FOOTER //
// ./src/components/library/button/Button.js